import { defineComponent as i, useCssModule as l, computed as c, openBlock as d, createBlock as m, resolveDynamicComponent as f, normalizeClass as p, unref as t, withCtx as u, renderSlot as C } from "vue";
import v from "../../utils/propValidator.mjs";
import g from "../../utils/mapClasses.mjs";
const a = "cdr-container", h = /* @__PURE__ */ i({
  name: "CdrContainer",
  __name: "CdrContainer",
  props: {
    /** Sets the HTML tag for the container element */
    tag: {
      type: String,
      default: "div"
    },
    /**
      * Controls whether container is static or fluid width.
      * @demoSelectMultiple false
      * @values static, fluid
    */
    modifier: {
      type: String,
      default: "static",
      validator: (e) => v(e, ["static", "fluid"], !1)
    }
  },
  setup(e) {
    const o = e, s = l(), r = c(() => `${a}--${o.modifier}`);
    return (n, y) => (d(), m(f(e.tag), {
      class: p(t(g)(t(s), a, r.value))
    }, {
      default: u(() => [C(n.$slots, "default")]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  h as default
};
